import assessor from './assessor'
import assessorActivity from './assessorActivity'
import awardUnit from './awardUnit'
import leader from './leader'
import nextLevel from './nextLevel'
import organizationContact from './organizationContact'
import participant from './participant'
import React from 'react'
import config from 'config'
import {
  AssessorRejection,
  ParticipantReview
} from 'containers/pages'
import ParticipantReviewDenied from '../../containers/pages/ParticipantReviewDenied/ParticipantReviewDenied'

const urlPrefix = `${config.publicPath}/register`

export default [
  {
    path: `${urlPrefix}/assessor/invitation-rejection`,
    exact: true,
    component: props => (
      <AssessorRejection {...props} />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/participant/review`,
    exact: true,
    component: props => (
      <ParticipantReview {...props} />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/participant/review/denied`,
    exact: true,
    component: props => (
      <ParticipantReviewDenied {...props} />
    ),
    routes: []
  },

  ...assessor,
  ...assessorActivity,
  ...awardUnit,
  ...leader,
  ...nextLevel,
  ...organizationContact,
  ...participant
]
